import debug from 'debug';
import { isNil } from 'ramda';

import { TRequesterResponse } from './IRequester';

const log = debug('sunny:Requester');

export abstract class Requester<T> {
  id: string;
  start: Date | null = null;
  end: Date | null = null;
  duration: number | null = null;

  protected onStart(): void {
    log('onStart', this.id);
    this.start = new Date();
  }

  protected onEnd(): void {
    this.end = new Date();
    this.duration = this.getDuration(this.end);
    log('onEnd', this.id, `${this.duration}ms`);
  }

  protected getDuration(end: Date): number | null {
    this.duration = isNil(this.start) || isNil(end) ? null : end.getTime() - this.start.getTime();
    return this.duration;
  }

  abstract call<P>(config: T): Promise<TRequesterResponse<P>>;
}
